import { createUseStyles } from 'react-jss'

import { phonesDown, tabletDown } from '../const/breakpoints'
import { scrollableList, smallPageContainer } from '../common'
import { fontWeightBold } from '../typography'

const useStyles = createUseStyles({
  container: {
    extend: smallPageContainer,
    marginTop: 60
  },
  heading: {
    marginBottom: 24,
    '& p': {
      marginTop: 16,
      fontSize: 14,
      lineHeight: 1.1
    }
  },
  title: {
    fontWeight: fontWeightBold,
    fontSize: 18,
    marginBottom: 24
  },
  subTitle: {
    fontWeight: fontWeightBold,
    fontSize: 16,
    marginBottom: 24
  },
  pageSection: {
    '&:not(:last-child)': {
      marginBottom: 32
    }
  },
  icon: {
    marginTop: 40
  },
  formButtons: {
    marginTop: 24,
    display: 'flex',
    columnGap: 8
  },
  formRow: {
    display: 'flex',
    columnGap: 20
  },
  itemList: {
    padding: 0,
    extend: scrollableList
  },

  actionsCol: {
    paddingRight: '0 !important'
  },

  [`@media screen and (${tabletDown})`]: {
    wrapper: {
      marginTop: 20
    }
  },
  [`@media screen and (${phonesDown})`]: {
    formRow: {
      flexDirection: 'column'
    }
  }
})

export default useStyles
